export default __webpack_public_path__ + "static/media/Banner-resena-2-agenda.148f2f59.jpg";